import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconNames, IconNamesType } from './IconNames';

@Component({
  selector: 'pay-icon',
  imports: [NgClass],
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  readonly customViewBox = input('0 0 32 32');
  readonly size = input<'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'custom'>('md');
  readonly customSize = input<string>('');
  readonly shape = input<IconNamesType>('');
  readonly fillColor = input<string>();
  protected readonly IconNames = IconNames;

  getViewBox() {
    if (this.shape() === 'terminal') {
      return '200 0 600 1080';
    } else {
      return this.customViewBox();
    }
  }

  getIconSize() {
    switch (this.size()) {
      case 'xxs':
        return 'h-3 w-3';
      case 'xs':
        return 'h-4 w-4';

      case 'sm':
      default:
        return 'h-6 w-6';
      case 'md':
        return 'h-8 w-8';
      case 'lg':
        return 'h-8 w-8';
      case 'custom':
        return this.customSize();
    }
  }

  getClasses = () => {
    return `${this.getIconSize()}
     ${this.fillColor()} fill-${this.fillColor()}
    stroke-current object-contain
    ${this.shape() == 'building' ? 'p-1' : 'p-0'}`;
  };
}
